import { AgTechFormContext } from "@agtech/core/forms/AgTechFormContext";
import { AgTechFormReadOnlyTextControl } from "@agtech/web/components/Forms/Controls/AgTechFormReadOnlyTextControl";
import { AgTechFormTextAreaControl } from "@agtech/web/components/Forms/Controls/AgTechFormTextAreaControl";
import { AgTechFormTextControl } from "@agtech/web/components/Forms/Controls/AgTechFormTextControl";
import { AgTechFormRow } from "@agtech/web/components/Forms/Layout/AgTechFormRow";
import { AgTechFormSection } from "@agtech/web/components/Forms/Layout/AgTechFormSection";
import { SaleInvoiceDialogFormContext, SaleInvoiceDialogFormData } from "../InvoiceCreationDialog";
import AgTechFormBody from "@agtech/web/components/Forms/Layout/AgTechFormBody";
import SaleContactDetailDialog from "../../../../contacts/dialogs/SaleContactDetailDialog";
import { getContactFullName } from "@agtech/data/contacts/ContactData";
import InvoiceChangeLotsGrid from "../../../components/grids/InvoiceChangeLotsGrid";
import { buildGridEntitySelectionIndex } from "@agtech/web/components/Grids/AgTechGridEntities";

const InvoiceCreationGeneralInfoPage = (props: {
    formContext: AgTechFormContext<SaleInvoiceDialogFormData, SaleInvoiceDialogFormContext>
}) => {
    const invoiceData = props.formContext.entity;
    const invoiceContact = props.formContext.context.contactDetails.contact;

    return (
        <AgTechFormBody>
            <div id='invoice-create-general'>
            <AgTechFormSection
                header='General'
                headerContent={() => (
                    <SaleContactDetailDialog.Button
                        contactId={props.formContext.entity.contactId}
                        classes='button-thin p-0 button-link'
                    />
                )}
            >
                <AgTechFormRow>
                    <div className='row-based pr-6 flex'>
                        <div className='mb-auto'>
                            <AgTechFormReadOnlyTextControl
                                entityType={invoiceData}
                                caption='Bidder Number'
                                value={() => props.formContext.entity.bidderNumber ? props.formContext.entity.bidderNumber : 'N/A'}
                                controlStyles={{ width: 100 }}
                            />
                        </div>
                    </div>
                    <AgTechFormTextAreaControl
                        entityType={invoiceData}
                        caption='Contact information'
                        readonly={true}
                        value={() => `${getContactFullName(invoiceContact)} ${invoiceContact.ranchName ? ' - ' + invoiceContact.ranchName : ''}\n${invoiceContact.emailAddress}${invoiceContact.phoneNumber ? ' | ' + invoiceContact.phoneNumber : ''}\n\n${invoiceContact.address}\n${invoiceContact.city}, ${invoiceContact.stateAbbreviation} ${invoiceContact.zip}`}
                        width={100}
                        rows={5}
                        resizable={false}
                        styles={{ lineHeight: '20px' }}
                    />
                </AgTechFormRow>
            </AgTechFormSection>
            </div>
            <div id='invoice-create-lots'>
            <AgTechFormSection
                header={`Lots purchased (${props.formContext.entity.selectedLots.length})`}
                classes='flexed'
                bodyClasses='flexed pt-3'
                // headerContent={() => (
                //     <InvoiceSplitInvoiceDialog.Button
                //         text='Split lots'
                //         classes='thin link'
                //         invoiceData={props.formContext.entity}
                //         role='OA'
                //     />
                // )}
            >
                <InvoiceChangeLotsGrid
                    contactId={props.formContext.context.contactDetails.contact.id}
                    availableLots={buildGridEntitySelectionIndex({
                        entities: props.formContext.context.allLotsPurchasedByContact,
                        isSelected: lot => props.formContext.entity.selectedLots.some(l => l.id === lot.id)
                    })}
                    onLotSelected={async selectedLot => {
                        props.formContext.updateFormEntity(curr =>({
                            ...curr,
                            selectedLots: [...curr.selectedLots, selectedLot]
                        }));
                    }}
                    onLotDeSelected={async deselectedLot => {
                        props.formContext.updateFormEntity(curr =>({
                            ...curr,
                            selectedLots: curr.selectedLots.filter(lot => lot.id !== deselectedLot.id)
                        }));
                    }}
                />
            </AgTechFormSection>
            </div>
        </AgTechFormBody>
    )
}

export default InvoiceCreationGeneralInfoPage;